"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteCouponApi = DeleteCouponApi;
exports.addCouponApi = addCouponApi;
exports.addFundsRecordsApi = addFundsRecordsApi;
exports.batchApi = batchApi;
exports.bindSupplierApi = bindSupplierApi;
exports.categoryApi = categoryApi;
exports.customerSuppliersApi = customerSuppliersApi;
exports.deleteProductsApi = deleteProductsApi;
exports.deleteSupplierApi = deleteSupplierApi;
exports.detailCouponApi = detailCouponApi;
exports.devConfigApi = devConfigApi;
exports.editCouponApi = editCouponApi;
exports.fundsRecordsApi = fundsRecordsApi;
exports.fundsRecordsDetailApi = fundsRecordsDetailApi;
exports.getActiveCustomersApi = getActiveCustomersApi;
exports.getCompanyListApi = getCompanyListApi;
exports.getCompanyOptionsApi = getCompanyOptionsApi;
exports.getCustomersApi = getCustomersApi;
exports.getSupplieGoodsrApi = getSupplieGoodsrApi;
exports.getSupplierApi = getSupplierApi;
exports.getSupplierEditInfoApi = getSupplierEditInfoApi;
exports.productsPageApi = productsPageApi;
exports.updateDevApi = updateDevApi;
exports.updatePriceApi = updatePriceApi;
exports.updatePriceRecordApi = updatePriceRecordApi;
exports.updateSupplierApi = updateSupplierApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * 查询公司
 */
function getCompanyListApi(str) {
  return (0, _request.default)({
    url: "/admin/business/company/list/".concat(str ? str : ''),
    method: 'GET'
  });
}

/**
 * 模糊查询公司
 */
function getCompanyOptionsApi(par) {
  var data = _objectSpread(_objectSpread({}, par), {}, {
    status: 1
  });
  return (0, _request.default)({
    url: "/admin/business/company/options",
    method: 'GET',
    params: data
  });
}

/**
 * 查询客户列表
 */
function getCustomersApi(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/customer/list',
    method: 'GET',
    params: params
  });
}

/**
 * 添加客户
 */
function addCouponApi(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/customer/save',
    method: 'POST',
    data: data
  });
}
/**
 * 删除客户
 */
function DeleteCouponApi(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/customer/delete/".concat(id),
    method: 'DELETE'
  });
}
/**
 * 修改客户
 */
function editCouponApi(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/customer/update',
    method: 'post',
    data: data
  });
}

/**
 * 客户详情
 */
function detailCouponApi(id) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/customer/detail/${id}',
    method: 'GET'
  });
}

/**
 * 商品分类
 * @param pram
 */
function categoryApi(params) {
  // return request({
  //   url: '/admin/category/list/tree',
  //   method: 'GET',
  //   params,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/product/category/list/tree',
    method: 'GET',
    params: params
  });
}

/**
 * 开发配置
 */
function devConfigApi(customerNumber) {
  return (0, _request.default)({
    url: "/admin/dev-config/".concat(customerNumber),
    method: 'GET'
  });
}

/**
 * 资金记录列表
 */
function fundsRecordsApi(params) {
  return (0, _request.default)({
    url: "/admin/funds-records/page-list",
    method: 'GET',
    params: params
  });
}
/**
 * 添加资金记录
 */
function addFundsRecordsApi(data) {
  return (0, _request.default)({
    url: "/admin/funds-records/add",
    method: 'POST',
    data: data
  });
}
/**
 * 资金记录详情
 */
function fundsRecordsDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/funds-records/".concat(id),
    method: 'GET'
  });
}

/**
 * 更新开发配置
 */
function updateDevApi(data) {
  return (0, _request.default)({
    url: "/admin/dev-config",
    method: 'POST',
    data: data
  });
}

/**
 * 查询供应商
 */
function getSupplierApi(params) {
  return (0, _request.default)({
    url: "/admin/business/supplier/list",
    method: 'GET',
    params: params
  });
}

/**
 * 查询供应商商品
 */
function getSupplieGoodsrApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/products/for-new/".concat(params.supplierId),
    method: 'GET',
    params: params
  });
}

/**
 * 绑定供应商
 */
function bindSupplierApi(data) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/bind-supplier",
    method: 'POST',
    data: data
  });
}

/**
 * 编辑供应商
 */
function updateSupplierApi(data) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/bind-supplier/products/update",
    method: 'POST',
    data: data
  });
}

/**
 * 获取客户供应商绑定分页列表（客户产品配置---供应商绑定---分页查询接口）
 */
function customerSuppliersApi(customerId) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/page-list/".concat(customerId),
    method: 'GET'
  });
}

/**
 * 查询指定客户关联的商品列表（客户产品配置---产品列表---分页查询接口
 */
function productsPageApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/products/page",
    method: 'GET',
    params: params
  });
}

/**
 * 移除客户关联的商品(客户产品配置---产品列表中---移除商品
 */
function deleteProductsApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/products/remove",
    method: 'DELETE',
    params: params
  });
}

/**
 * 移除客户关联的供应商（客户产品配置---供应商绑定---移除接口）
 */
function deleteSupplierApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/bind-supplier/".concat(params.customerId, "/").concat(params.supplierId),
    method: 'DELETE'
  });
}

/**
 * 更新商品价格
 */
function updatePriceApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/product/price",
    method: 'PUT',
    params: params
  });
}

/**
 * 改价记录列表
 */
function updatePriceRecordApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers",
    method: 'GET',
    params: params
  });
}

/**
 * 查询客户关联的供应商和商品列表（客户产品配置---供应商绑定---编辑回显数据接口
 */
function getSupplierEditInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/products/edit/".concat(params.customerId, "/").concat(params.supplierId),
    method: 'GET'
  });
}

/**
 * 批量改价操作
 */
function batchApi(data) {
  return (0, _request.default)({
    url: "/admin/customer-suppliers/batch",
    method: 'POST',
    data: data
  });
}

/**
 * 获取商户
 */
function getActiveCustomersApi() {
  // return request({
  //   url: `/admin/customers/active-customers`,
  //   method: 'GET',
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/user/customer/active-customers",
    method: 'GET'
  });
}